import getCookie from './GetCookie';

function getPostBody(data, contentType) {
    switch (contentType) {
        case 'application/x-www-form-urlencoded':
            var formBody = new URLSearchParams();
            for (var key in data) {
                formBody.append(key, data[key]);
            }
            return formBody;
        case "FormData":
            return data;
        default:
            return JSON.stringify(data);
    }
}

export default async function postData(url = '', data = {}, contentType='application/json') {
    const customHeaders = {
        'X-CSRFToken': getCookie('csrftoken')
    }
    if(contentType!=="FormData"){
        customHeaders['Content-Type']  = contentType;
    }
    const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: customHeaders,
        referrer: 'no-referrer',
        body: getPostBody(data, contentType)
    });

    return await response.json();
}